import classNames from 'classnames';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import DROPSHIPPING_REQUEST_COMPANY from '../../../../components/constant/dropshippingRequestCompany';

const useStyles = makeStyles({
  itemStatusApproved: { color: '#4caf50' },
  itemStatusPending: { color: '#ff9800' },
  itemStatusDisapproved: { color: '#dc004e' },
});

interface IProps {
  status: string;
}

export default function LabelDropshippingRequestCompanyStatus(props: IProps) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { status } = props;

  return (
    <Typography
      variant="subtitle1"
      display="inline"
      className={classNames({
        [classes.itemStatusApproved]:
          status === DROPSHIPPING_REQUEST_COMPANY.STATUS.APPROVED,
        [classes.itemStatusPending]:
          status === DROPSHIPPING_REQUEST_COMPANY.STATUS.PENDING,
        [classes.itemStatusDisapproved]:
          status === DROPSHIPPING_REQUEST_COMPANY.STATUS.DISAPPROVED,
      })}
    >
      {t(status)}
    </Typography>
  );
}
